import React, { FunctionComponent, useRef } from "react";
import { Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Dialog, Button, HighlightedText } from "@shared/components";
import { wireInstructionMessages, WireFundType } from "@investorRequest/constants/wireInstructionMessages";

const useStyles = makeStyles((theme) => ({
  message: {
    textAlign: "center",
    fontSize: 18,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(4),
  },
  buttonContainer: {
    display: "flex",
    gap: theme.spacing(4),
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      gap: theme.spacing(3),
    },
  },
}));

interface SubmitWireUpdateConfirmDialogProps {
  open: boolean;
  fundType: WireFundType;
  onConfirm: () => void;
  onCancel: () => void;
}

const SubmitWireUpdateConfirmDialog: FunctionComponent<SubmitWireUpdateConfirmDialogProps> = ({
  open,
  fundType,
  onConfirm,
  onCancel,
}) => {
  const classes = useStyles();

  // Retain the last fundType while closing so the parent's fallback doesn't flip
  // the copy during the dialog's exit transition.
  const displayedFundType = useRef<WireFundType>(fundType);

  if (open) {
    displayedFundType.current = fundType;
  }
  const { header, body } = wireInstructionMessages.confirmDialog[displayedFundType.current];

  return (
    <Dialog open={open} onClose={() => onCancel()} title={header} maxWidth="sm" fullWidth closeOnBackdropClick={false}>
      <Box>
        <Typography className={classes.message}>
          <HighlightedText text={body} />
        </Typography>
        <Box className={classes.buttonContainer}>
          <Button
            variant="contained"
            color="primary"
            shape="rounded"
            onClick={onConfirm}
            size="medium"
            testId="submit-wire-update-confirm"
          >
            Submit Request
          </Button>
          <Button
            variant="outlined"
            color="primary"
            shape="rounded"
            onClick={onCancel}
            size="medium"
            testId="submit-wire-update-cancel"
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default SubmitWireUpdateConfirmDialog;
